const json = require('./index.json');

exports.color = json.color;
exports.space = json.space;
exports.fontFamily = json.fontFamily;
exports.fontSettings = json.fontSettings;
exports.fontSize = json.fontSize;
exports.fontWeight = json.fontWeight;
exports.lineHeight = json.lineHeight;
exports.breakpoint = json.breakpoint;
exports.minBreakpoint = json.minBreakpoint;
exports.shadow = json.shadow;
exports.borderRadius = json.borderRadius;
exports.transition = json.transition;
exports.primitives = json;
